import $i18n, { useI18n } from '@alife/panda-i18n';
import React, { useState, useEffect } from 'react';
import { CnIcon, CnTooltip } from '@alife/cn-ui';
import { motion } from 'framer-motion';
import { logCustom, logError } from 'src/utils/tracker';
import './index.scss';
import { PanelType } from 'src/types';
const key = 'QUESTIONNAIRE_TIP';
function getQuestionnaireTipFlag(unicode) {
    try {
        let obj = localStorage.getItem(key);
        if (obj) {
            obj = JSON.parse(obj);
            if (obj[unicode]) {
                return true;
            }
        }
    }
    catch (error) {
        logError(error, {
            c2: 'get questionnaire tip flag fail'
        });
        console.error(error);
    }
    return false;
}
function setQuestionnaireTipFlag(unicode) {
    try {
        let obj = localStorage.getItem(key);
        if (obj) {
            obj = JSON.parse(obj);
        }
        else {
            obj = {};
        }
        obj[unicode] = 1;
        localStorage.setItem(key, JSON.stringify(obj));
    }
    catch (error) {
        logError(error, {
            c2: 'set questionnaire tip flag fail'
        });
    }
}
export function isShowQuestionnaire(config) {
    const questionnaire = config?.xlPanelConfigDTOList?.find((m) => m?.panelConfigCode === PanelType.questionnaire);
    return !!questionnaire?.data?.questionnaireUrl;
}
export function QuestionnaireTip(props) {
    const { config, userId, userSystem } = props;
    const { xlPanelConfigDTOList, code } = config;
    const questionnaire = xlPanelConfigDTOList?.find((m) => m?.panelConfigCode === PanelType.questionnaire);
    const unicode = `${code}-${userSystem}-${userId}-${questionnaire?.data?.questionnaireUrl}`;
    const isMarked = getQuestionnaireTipFlag(unicode);
    const [visible, setVisible] = useState(!isMarked);
    // console.log('config', config);
    const onClickQuestionnaire = (e) => {
        e.stopPropagation();
        props.onTypeClick(PanelType.questionnaire, questionnaire?.data?.questionnaireUrl);
        setVisible(false);
        setQuestionnaireTipFlag(unicode);
        logCustom('CLK_questionnaire_tip_quick', questionnaire?.data?.questionnaireUrl, config.code);
    };
    useEffect(() => {
        setQuestionnaireTipFlag(unicode);
    }, []);
    if (!visible || !questionnaire)
        return null;
    return (React.createElement(motion.div, { className: 'cn-intelli-assistant-questionnaire-tip', onClick: (e) => e.stopPropagation() },
        React.createElement("p", { className: 'cn-intelli-assistant-questionnaire-tip-title' }, $i18n.get({
            id: 'XiaoLing',
            dm: '小灵”'
        })),
        React.createElement("p", null, $i18n.get({
            id: 'WeSincerelyInviteYouToParticipate_756697533.ued',
            dm: '诚邀您参加“问卷调研”'
        })),
        React.createElement("p", null,
            React.createElement("span", { className: 'cn-intelli-assistant-questionnaire-tip-btn', onClick: onClickQuestionnaire },
                $i18n.get({
                    id: 'ParticipateNow.ued',
                    dm: '立即参与'
                }),
                React.createElement(CnIcon, { type: 'arrow-right', size: 'small' })))));
}
export default function QuickEntry(props) {
    const { config } = props;
    const { xlPanelConfigDTOList } = config;
    const $i18n = useI18n();
    const questionnaire = xlPanelConfigDTOList?.find((m) => m?.panelConfigCode === PanelType.questionnaire);
    const onClickQuestionnaire = (e) => {
        e.stopPropagation();
        logCustom('CLK_questionnaire_quick', questionnaire?.data?.questionnaireUrl, config.code);
        props.onTypeClick(PanelType.questionnaire, questionnaire?.data?.questionnaireUrl);
    };
    return questionnaire ? (React.createElement("div", { className: 'cn-ui-intelli-assistant-quick-entry' }, questionnaire && (React.createElement(CnTooltip, { align: 'l', trigger: React.createElement(motion.div, { className: 'cn-ui-intelli-assistant-quick-entry-icon', onClick: onClickQuestionnaire },
            React.createElement(CnIcon, { type: 'text-edit', size: 'large' })) }, $i18n.get({
        id: 'TheQuestionnaireIsComingPleaseFill_2984281246.ued',
        dm: '调查问卷来咯，请填写'
    }))))) : null;
}
